import http from './api';

const getContacts = () => http.get('api/crm/contact/all');
const getLists = () => http.get('api/crm/lists');
const createList = list => http.post('api/crm/lists', list);
const deleteList = listId => http.delete(`api/crm/lists/${listId}`);
const getListContacts = listId => http.get(`api/crm/lists/${listId}/contacts`);
const assignContactToList = (contactId, listId) => http.post(`api/crm/lists/${listId}/contacts/${contactId}`);
const removeContactFromList = (contactId, listId) => http.delete(`api/crm/lists/${listId}/contacts/${contactId}`);
const getContact = contactId => http.get(`api/crm/contact/${contactId}`);
const searchContactsAdvanced = (query, config) =>
  http.get(`api/crm/advancedSearch?${new URLSearchParams(query).toString()}`, config);
const searchContacts = (query, config) =>
  http.get(`api/crm/basicSearch?${new URLSearchParams(query).toString()}`, config);
const addNote = (contactId, note) => http.post(`api/crm/contact/${contactId}/notes`, { note });
const getNotes = contactId => http.get(`api/crm/contact/${contactId}/notes`);
const getNotesBatch = contactIds => http.post(`api/crm/contact/notes/batch`, { userIds: contactIds });
const createContact = contact => http.post(`api/crm/contact`, contact);
const updateContact = (contactId, fields) => http.put(`api/crm/contact/${contactId}/properties`, fields);
const deleteContact = contactId => http.delete(`api/crm/contact/${contactId}`);
const getCrmTemplates = () => http.get(`api/crm/templates`);

export default {
  getContacts,
  getLists,
  createList,
  deleteList,
  getListContacts,
  assignContactToList,
  removeContactFromList,
  getContact,
  searchContactsAdvanced,
  searchContacts,
  addNote,
  getNotes,
  getNotesBatch,
  createContact,
  updateContact,
  deleteContact,
  getCrmTemplates
};
